// extracted by mini-css-extract-plugin
export var actions = "_dj-d";
export var benefitCard = "_dj-a";
export var benefitIcon = "_dj-b";
export var benefitLabel = "_dj-c";
export var benefits = "_dj-9";
export var bodyText = "_dj-8";
export var closeButton = "_dj-2";
export var content = "_dj-3";
export var eyebrow = "_dj-4";
export var heading = "_dj-5";
export var image = "_dj-f";
export var imagePanel = "_dj-e";
export var modal = "_dj-0";
export var shell = "_dj-1";
export var title = "_dj-6";
export var titleOffer = "_dj-7";